import { ROLES } from 'config';

const subscriptionsConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('subscriptions', {
      url: '/subscriptions',
      template: '<app-subscriptions></app-subscriptions>',
      access: {
        loginRequired: true,
        roles: [ROLES.USER],
      },
    });
};

export default subscriptionsConfig;



// WEBPACK FOOTER //
// ./src/modules/subscriptions/subscriptions.config.js